import { IUser } from 'models/IUser';
import { UsersActionTypes, UsersActions } from './types';


export interface UserState {
  isLoading: boolean;
  users: IUser[];
  error: string | null;
}

const initialState: UserState = {
  isLoading: false,
  users: [],
  error: null,
};

export default function userReducer(
  state = initialState,
  action: UsersActions
): UserState {
  switch (action.type) {
    case UsersActionTypes.GET_USERS_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case UsersActionTypes.GET_USERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        users: action.payload.users,
        error: null,
      };
    case UsersActionTypes.GET_USERS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}